import { render, staticRenderFns } from "./ResourceCreateTags.vue?vue&type=template&id=02d378c0&"
import script from "./ResourceCreateTags.vue?vue&type=script&lang=js&"
export * from "./ResourceCreateTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02d378c0')) {
      api.createRecord('02d378c0', component.options)
    } else {
      api.reload('02d378c0', component.options)
    }
    module.hot.accept("./ResourceCreateTags.vue?vue&type=template&id=02d378c0&", function () {
      api.rerender('02d378c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/resources/steps/ResourceCreateTags.vue"
export default component.exports